import gql from 'graphql-tag';

export const GET_ALL_RESOURCES = gql`
  query getAllResources {
    getAllResources {
      id
      name
      state
      boondmanagerId
      assignments {
        id
        startDate
        endDate
        numberWeek
        percentage
        project {
          id
          name
        }
        resource {
          id
          name
        }
        assignmentDetail {
          assignmentId
          week
          year
          daysAvailable
          daysWorked
          validated
        }
      }
      leaves {
        boondmanagerId
        idProfil
        week
        year
        duration
      }
    }
  }
`;

export const GET_ALL_PROJECTS = gql`
  query getAllProjects {
    getAllProjects {
      id
      name
      budget
      activity
      boondmanagerId
      startDate
      endDate
      type
      managers {
        id
        name
        boondmanagerId
      }
      consumed
      assignments {
        id
        startDate
        endDate
        percentage
        project {
          id
          name
        }
        resource {
          id
          name
        }
        assignmentDetail {
          assignmentId
          week
          year
          daysAvailable
          daysWorked
        }
      }
    }
  }
`;

export const GET_FOLLOWING_WEEKS = gql`
  query getFollowingWeeks($number: Int!) {
    getFollowingWeeks(number: $number) {
      id
      year
      month
      week
      firstDate
      lastDate
    }
  }
`;

export const GET_ALL_USERS = gql`
  query getAllUsers {
    getAllUsers {
      id
      email
      role
    }
  }
`;
